import { gql } from '@apollo/client'

export default gql`
  fragment dashboardChecklistStatusInfo on DashboardChecklistStatus {
    status
    averageDays
    uniqueCarCount
  }
`
